import { ToastDesignTokens } from '@primeng/themes/types/toast';

export const baseToastToken: ToastDesignTokens = {
  root: {
    borderRadius: '0.5rem',
    borderWidth: '0',
  },
  content: {
    padding: '0',
    gap: '0',
  },
  colorScheme: {
    light: {
      success: {
        background: 'linear-gradient(270deg, #02699C 0%, #00304D 100%);',
        shadow: '0 0.25rem 1.25rem 0 #00000040',
      },
      info: {
        background: '#FFFFFF',
        shadow: '0 0.25rem 1.25rem 0 #00000040',
      },
    },
  },
  css: () => `
    p-toast.fix-absolute .p-toast {
     position: absolute !important;
    }

    p-toast.fix-absolute.fix-clamp-left .p-toast-top-center {
      left: 0 !important;
      transform: translateX(min(calc(100vw - 100% - 0.75rem), max(0.75rem, calc(50cqw - 50%)))) !important;
    }
    `,
};
